define([
    'text!index2021-job/component/main.html',
    'common/api',
    'jquery',
    'WebCommon/utils',
    'WebCommon/component/image-link-slick',

    'css!index2021-job/component/main.css'
], function(
    tpl,Api,$,Utils,
    ImageLinkSlick
){
    return {
        template: tpl,
        data: function(){
            return {
                isPC: true,
                jobs: {},
                activeAddr:'',
                jobHeight: []
            };
        },
        components: {


        },
        computed: {

        },
        created: function () {
            var obj = this;


        },
        methods: {
            init: function () {
                var obj = this;
                if($(window).width()<=750){
                    obj.isPC = false;
                    $('.fixed-menu').css({display: 'none'});
                }else {
                    obj.isPC = true;
                }
                Api.getAllJobs.ajax({})
                    .done(function (data) {
                        obj.jobs = data;
                        obj.activeAddr = '北京总部';
                        Utils.emitPageReady();
                        obj.getHeight();
                });
            },
            getHeight: function () {
                var obj = this;
                obj.jobHeight = [];
                obj.$nextTick(function(){
                    // var h = $(window).height()-248;
                    var h = $(window).height();
                    Object.keys(obj.jobs).forEach(function (depart,index) {
                        h = h + $('#job-' + depart).height()+80;
                        // if(index===0){
                        //     obj.jobHeight.push({name:'#job-'+depart,sumHeight: h+248,height: $('#job-' + depart).height()+80});
                        // }else {
                            obj.jobHeight.push({name:'#id-'+depart,sumHeight: h,height: $('#job-' + depart).height()+80});
                        // }
                    });
                    // obj.toScroll();
                })
            },
            toScroll: function () {
                var obj = this;
                var wh = $(window).height();
                var scrollTop = $(window).scrollTop();
                if(scrollTop>=wh){
                    $(".index2021-job-header").css({position:'fixed',top:0,left:0,'z-index':10});
                }else {
                    $(".index2021-job-header").css({position:'relative'});
                }
                // var scrollTo = scrollTop
                console.log(scrollTop);
                obj.jobHeight.forEach(function (item,index) {
                    var theHeight = item.sumHeight-item.height;
                    if(scrollTop>=theHeight&&scrollTop<item.sumHeight-50){
                        $(item.name).css({position:'fixed',top:'248px',left:'3%','z-index':5});
                    }else if(scrollTop>=item.sumHeight-50&&scrollTop<item.sumHeight){
                        var top = 248-(50-item.sumHeight+scrollTop);
                        $(item.name).css({position:'fixed',top:top+'px',left:'3%','z-index':5});
                    }else if(scrollTop>=item.sumHeight){
                        $(item.name).css({position:'fixed',top:'198px',left:'3%','z-index':5});
                    }else {
                        $(item.name).css({position:'relative',top:'0',left:'0','z-index':0});
                    }
                });
            }
        },
        mounted: function(){
            this.init();
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                obj.getHeight();
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
            $(window).scroll(function () {
                // obj.toScroll();
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-job/component/main.js
// module id = 279
// module chunks = 7